const getAbsoluteUrlForCurrentHost = path => `${global.location.protocol}//${global.location.hostname}${global.location.port ? `:${global.location.port}` : ''}${path}`

export default getAbsoluteUrlForCurrentHost



// WEBPACK FOOTER //
// ./src/utilities/getAbsoluteUrlForCurrentHost.js